import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Upload, Button, Typography } from 'antd'
import { selectFileAction } from './types'
import { RcFile } from 'antd/lib/upload'
import { FormattedMessage } from 'react-intl'
import { DownloadOutlined } from '@ant-design/icons'
import Template from '../../assets/template.xlsx'

import styled from 'styled-components'

const ButtonRow = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

const validFormat = (f: RcFile) =>
  f.type === 'application/vnd.ms-excel' ||
  f.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

const SizedDragger = styled.div`
  display: block;
  margin: auto;
  height: 200px;
  max-width: 400px;
`

const Import = () => {
  const dispatch = useDispatch()

  const [file, setFile] = React.useState<RcFile | undefined>(undefined)

  return (
    <>
      <Typography.Paragraph>
        <FormattedMessage id="importInstructions" />
      </Typography.Paragraph>
      <Button type="link" icon={<DownloadOutlined />} href={Template}>
        <FormattedMessage id="downloadTemplate" />
      </Button>
      <SizedDragger>
        <Upload.Dragger
          fileList={[]}
          name="excel-file"
          listType="text"
          beforeUpload={f => {
            setFile(f)
            return Promise.resolve()
          }}
        >
          {!file ? (
            <FormattedMessage id="uploadInstructions" />
          ) : !validFormat(file) ? (
            <FormattedMessage id="selectExcel" />
          ) : (
            <FormattedMessage
              id="importFileText"
              values={{ name: file.name }}
            />
          )}
        </Upload.Dragger>
      </SizedDragger>
      <ButtonRow>
        <Button
          disabled={!file || !validFormat(file)}
          onClick={!!file ? () => dispatch(selectFileAction(file)) : undefined}
          type="primary"
        >
          <FormattedMessage id="next" />
        </Button>
      </ButtonRow>
    </>
  )
}

export default Import
